module.exports = __webpack_public_path__ + "static/media/offices (13).3b55a013.webp";